export default {
  methods: {
    isMobile() {
        return this.$store.state.screen === 'mobile';
    },
    isDesktop() {
        return this.$store.state.screen === 'desktop';
    },
    setCurrentHref(href) {
        sessionStorage.setItem('currentHref', href ?? location.href)
    },
    getCurrentHref() {
      this.currentHref = sessionStorage.getItem('currentHref') ? sessionStorage.getItem('currentHref') : '/'
      return this.currentHref
    },
    removeCurrentHref() {
      sessionStorage.removeItem('currentHref')
    },
    gotoBackURI(backUri) {
      this.removeCurrentHref()
      location.href = backUri
    }
  }
}